<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;height: 100%; min-height: 726px;background: #fff;">
        <div class="table-list" >
            <div class="table-list-title">
                <span class="myTitle">我的登记</span>
                <div class="choose-group">
                    <span class="choose-group-span">登记日期</span>
                    <Date-picker
                            v-model="dateValue"
                            format="yyyy-MM-dd"
                            type="daterange"
                            placement="bottom-end"
                            @on-change="timeChange"
                            placeholder="选择日期"
                            style="width: 200px"
                    ></Date-picker>
                    <span class="choose-group-span">作品名称</span>
                    <i-input
                            v-model="workFullname"
                            ref="workFullnameInput"
                            :search="true"
                            @on-search="searchReset"
                            placeholder="请输入作品名称"
                            style="width: 205px"
                            class="select-input-style"
                    ></i-input>
                    <button @click="searchReset" class="btn-84 addBtn" >查询</button>
                </div>
            </div>

            <Row class="table-style-size">
                <i-col span="6">作品名称</i-col>
                <i-col span="6">提交时间</i-col>
                <i-col span="6">办理时长</i-col>
                <i-col span="6">作品保护情况</i-col>

                <i-col span="6">登记状态</i-col>
                <i-col span="6">操作</i-col>
            </Row>

            <errorTips :state="0" v-if="loadFlag && lawList.length == 0"></errorTips>

            <div v-else>
                <!--       数据列表         -->
                <Row class="table-style-size table-style-body" v-for="(item,index) in lawList" :key="index">
                    <i-col span="6">
                        <Tooltip :content="item.workFullName" placement="top">
                           <div class="notwrap">{{item.workFullName}} </div>
                        </Tooltip>
                    </i-col>
                    <i-col span="6" class="notwrap">{{item.createDate}}</i-col>
                    <i-col span="6" class="notwrap">
                        {{item.urgentDayType?item.urgentDayType:'---'}}
                    </i-col>
                    <i-col span="6">
                        <Tooltip v-if="item.status != 'identify'" content="登记证书" placement="top">
                            <img  style="width:24px;height:24px;margin:auto" src="@/assets/dw.png" alt="">
                        </Tooltip>
                        <Tooltip v-else content="登记证书" placement="top">
                            <img  style="width:24px;height:24px;margin:auto" src="@/assets/dy.png" alt="">
                        </Tooltip>
                    </i-col>
                    <i-col span="6">

                        <span v-if="item.status == 'wait_identify'">待审核</span>
                        <span v-if="item.status == 'identifying'">审核中</span>
                        <span v-if="item.status == 'identify'">审核通过</span>
                        <span v-if="item.status == 'reject_disable'">驳回不可编辑</span>
                        <span v-if="item.status == 'reject_enable'">驳回可编辑</span>
                    </i-col>
                    <i-col span="6">

                        <button @click="goDetailsid(item)" class="btn-84 addBtn" >查看详情</button>
                    </i-col>
                </Row>

                <!--       分页     -->
                <div style="height:80px"></div>
                <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {getCopyrightRegisterListGangAn} from '@/api/staticPage'
    import Cookies from "js-cookie";
    import errorTips from '@/views/main-components/error-tips';


    export default {
        metaInfo: {
            title: '我的登记|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '登记服务订单,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'legal-order',
        components: {
            errorTips
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                total: 0,
                pageNumber: 1,
                pages: 1,
                pageSize: 9,
                serviceProduct: '', //服务产品
                dateValue: [], //日期数组
                lawList: [],
                workFullname: '',
                loadFlag:false //加载flag
            }
        },
        mounted() {
            this._getCopyrightRegisterListGangAn()
        },
        methods: {
            /*********获取数据内容********/
            _getCopyrightRegisterListGangAn() {
                let data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    createDateStart: this.dateValue[0],
                    createDateEnd: this.dateValue[1],
                    workFullName: this.workFullname,
                    sort: 'createDate',
                    order: 'desc'
                };
                getCopyrightRegisterListGangAn(data).then(res => {
                    if (res.code == 200) {
                        let result = res.result;
                        this.total = result.total - 0;
                        this.pages = result.pages;
                        this.lawList = result.records;
                        this.loadFlag = true;
                    } else {
                        toast(res.message);
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },

            /*********跳转详情页********/
            goDetailsid(item) {
                const newHref = this.$router.resolve({name: `/copyrightDetails?id=${item.orderSeqNo}&regType=02`})
                window.open(newHref.location.name,'_blank')
            },
            /*********编辑********/
            bianjiData(item){
                const newHref = this.$router.resolve({name: `/copyrightRegistration?id=${item.orderSeqNo}&regType=02`})
                window.open(newHref.location.name,'_blank')
            },

            /*********时间改变事件********/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset()
            },

            /*********页数改变事件********/
            changepage(index) {
                this.pageNumber = index;
                this._getCopyrightRegisterListGangAn()
            },

            /*********搜索重置事件********/
            searchReset() {
                this.pageNumber = 1;
                this._getCopyrightRegisterListGangAn();
            }
        }
    }
</script>
<style scoped lang="less">
.myTitle{
        font-size: 18px !important;
        font-weight: 700;
        position: relative;
        z-index: 2;
        &::before{
            content: '';
            position: absolute;
            width: 50px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 3px;
            z-index: -1;
        }
    }
    .addBtn{
        background: #fff !important;
        color: #2196F3 !important;
        border: solid 1px #2196F3 !important;
        border-radius: 4px !important;
    }
    .father-box-input{
        display: flex !important;
        align-items: center;
    }

</style>
